var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "3-D Cube Effect"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeCube) + " ")];
      },
      proxy: true
    }])
  }, [_c('swiper', {
    staticClass: "swiper-cube-effect",
    attrs: {
      "options": _vm.swiperOptions,
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr'
    }
  }, [_vm._l(_vm.swiperData, function (data, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('b-img', {
      attrs: {
        "src": data.img,
        "fluid": ""
      }
    })], 1);
  }), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }